import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-129e53d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "profile-menu--username",
  class: "gordita-500-14-m text-Text/text_high title-text"
}
const _hoisted_2 = {
  "data-testid": "profile-menu--email",
  class: "gordita-400-12 text-Text/text_medium title-text"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  "data-testid": "profile-menu--profile-settings-text",
  class: "ml-[10px] gordita-400-12 text-Text/text_high"
}
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = {
  "data-testid": "profile-menu--logout-text",
  class: "ml-[10px] gordita-400-12 text-Text/text_high"
}

import elementsIds from '@/const/elementIds.json';
import { IncrediMenu, IncrediList, IncrediItem } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, inject } from 'vue';
import { useRouter } from 'vue-router';
import { IKPlatformAuthentication } from '@/modules/platformAuthentication/platformAuthentication.injectionKeys';
import { useAuthentication_LogoutMutation, useUserQuery } from '@/graphql/codegen/generated/graphql';
import { IKCommonPersistentData } from '@/components/common/services/commonDataService.types';
import { useCommonPersistentDataProvider } from '@/components/common/services/commonDataService';


export default /*#__PURE__*/_defineComponent({
  __name: 'userProfileMenu',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:modelValue', value: boolean): void }), expose: any, slots: any, attrs: any }) {

useCommonPersistentDataProvider();
const platformAuthentication = inject(IKPlatformAuthentication);
const commonPersistentData = inject(IKCommonPersistentData);
const GQL_useLogoutMutation = useAuthentication_LogoutMutation();
const router = useRouter();


const GQL_userInfo = useUserQuery();
const user = computed(() => GQL_userInfo?.result?.value?.user);
const logout = async () => {
  commonPersistentData?.setDefaultPasswordNotifyClosed(false);
  await GQL_useLogoutMutation.mutate();
  platformAuthentication?.stop();
  await router.push({ name: 'login' });
};

// eslint-disable-next-line no-unused-vars


const goToUserProfile = () => {
  emit('update:modelValue', false);
  router.push({ name: 'userProfile.PersonalInfo' });
};

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(IbxScopedCss, { class: "!h-full" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediMenu), {
        "model-value": __props.modelValue,
        direction: 'middle-right',
        "offset-y": 4,
        "offset-x": -8,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => emit('update:modelValue', value))
      }, {
        content: _withCtx(() => [
          _createVNode(IbxScopedCss, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IncrediList), { class: "w-56" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IncrediItem), { class: "pointer-events-none" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(user)?.userName || ''), 1),
                      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(user)?.additionalInfo?.email || ''), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_separator, { class: "mb-[6px]" }),
                  (_unref(user)?.local)
                    ? (_openBlock(), _createBlock(_unref(IncrediItem), {
                        key: 0,
                        "data-testid": _unref(elementsIds).leftDrawer.userProfile.profileSettingsMenuItem,
                        class: "incredi-transition",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (goToUserProfile()))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_q_icon, {
                              "data-testid": "profile-menu--profile-settings-icon",
                              class: "uil uil-user-circle text-Text/text_lowest text-[24px]"
                            }),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('userProfile.myProfileMenu.title')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["data-testid"]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IncrediItem), {
                    "data-testid": _unref(elementsIds).leftDrawer.userProfile.logOutMenuItem,
                    class: "incredi-transition",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (logout()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_q_icon, {
                          "data-testid": "profile-menu--logout-icon",
                          class: "uil uil-sign-out-alt text-Text/text_lowest text-[24px]"
                        }),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('userProfile.myProfileMenu.logOut')), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["data-testid"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["model-value"])
    ]),
    _: 3
  }))
}
}

})